import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

export const ADMIN_WEIGHT_UNITIES_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/weight-unities`;

export const ADMIN_WEIGHT_UNITIES_API_PATHS = {
  GET_WEIGHT_UNITIES: `${ADMIN_WEIGHT_UNITIES_API_ROOT}`,
  CREATE_WEIGHT_UNITY: `${ADMIN_WEIGHT_UNITIES_API_ROOT}`,
  UPDATE_WEIGHT_UNITY: (weightUnityId: string) => `${ADMIN_WEIGHT_UNITIES_API_ROOT}/${weightUnityId}`,
};
